export const yesNoOptions = [
  { label: "Yes", value: "Y" },
  { label: "No", value: "N" },
];



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/components/constants.js